import { _ } from "libs";

import React, { useState, useEffect } from "react";
import Tabs from "./tabs";
import { WaitingReservation } from "../../types";
import { getWaitingReservations, cancelWaitingReservation } from "../../actions";
import Loader from "../../components/loader";
import WaitingReservationsList from "../../components/waitingReservationsList";

const WaitingList = () => {
	const [waitingList, setWaitingList] = useState([] as WaitingReservation[]);
	const [loading, setLoading] = useState(true);

	const reloadReservations = () => {
		getWaitingReservations(0, 50).then(({ waitingList }) => {
			setWaitingList(waitingList);
			setLoading(false);
		});
	};

	useEffect(() => {
		reloadReservations();
	}, []);

	const cancel = async (uuid: string) => {
		if (window.confirm(_("waitingList.cancel.prompt"))) {
			setLoading(true);
			await cancelWaitingReservation(uuid);
			reloadReservations();
		}
	};

	return (
		<div className="reservationsPage hasSubheader">
			<Tabs />
			<div className="wrap">
				<div className="contentWrapper">
					<div className="contentLeft">
						{loading ? (
							<Loader />
						) : (
							<WaitingReservationsList reservations={waitingList} onDeleteClick={cancel} />
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default WaitingList;
